function cnpjFormat(cnpj: string): string {
  if (!cnpj) {
    return '';
  }

  return cnpj
    .replace(/\W/g, '')
    .replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\d{2})/g, '$1.$2.$3/$4-$5');
}

export { cnpjFormat };
